export const PAYFAIL_CALL_US_NUMBER = '0330 159 8704';
export const PAYFAIL_CALL_US_HREF = 'tel:03301598704';

export const PAYFAIL_CALL_US_TITLE = 'Your payment has failed';
export const PAYFAIL_CALL_US_BODY = 'We’re here to help. Please give us a call to discuss your payment options and keep your breakdown cover valid. Failure to pay could impact your credit rating.';
export const PAYFAIL_CALL_US_EARLY_CANCELLED_TITLE = 'Restart your direct debit';
export const PAYFAIL_CALL_US_EARLY_CANCELLED_BODY = 'There’s been an issue with your payment. Call us as soon as possible to ensure your breakdown cover remains valid.';
